import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M11 2a9 9 0 110 18 9 9 0 010-18zm0 16a7 7 0 100-14 7 7 0 000 14z"/>
    <path fill="#34CEFF" d="M22.31 20.9l-2.82-2.83-1.42 1.41 2.83 2.83 1.41-1.41z"/>
  </SvgIcon>
);